var crq = require("./config.js");
var crr = require("./utils.js");
var crs = require("./antihackkey.json");
module.exports = {
  ahNum: 0,
  socket: null,
  connected: false,
  socketId: -1,
  sendQueue: [],
  connect: function (crn, cro, crp) {
    if (!this.eECZL) {
      var crs = crq.enableHttps ? "wss:" : "ws:";
      var crx = this;
      try {
        var cry = false;
        this.eECZL = new WebSocket(crs + crn);
        this.eECZL.binaryType = "arraybuffer";
        this.eECZL.onmessage = function (crn) {
          var cro = crr.decodeNetworkMessage(crn.data)[0];
          var crq = cro[0];
          var crs = cro[1];
          if (crq == "io-init") {
            crx.socketId = crs[0];
          } else if (crp[crq]) {
            crp[crq].apply(undefined, crs);
          } else {
            console.error("Received unregistered event", crq);
          }
        };
        this.eECZL.onopen = function () {
          crx.connected = true;
          cro();
          for (let crn of crx.sendQueue) {
            crx.send(crn[0], ...crn[1]);
          }
        };
        this.eECZL.onclose = function () {
          crx.connected = false;
          if (!cry) {
            cro("Disconnected. Try connecting to another server.");
          }
        };
        this.eECZL.onerror = function () {
          if (this.eECZL.readyState != WebSocket.OPEN) {
            cry = true;
            console.error("Socket error", arguments);
            cro("Socket error");
          }
        };
      } catch (crE) {
        console.error("Socket connection error:", crE);
        cro(crE);
      }
    }
  },
  send: function (crn, ...cro) {
    if (!this.eECZL || this.eECZL.readyState !== WebSocket.OPEN) {
      console.warn("Socket not open yet", crn, cro);
      this.sendQueue.push([crn, cro]);
      return;
    }
    this.ahNum = crr.rotateNumber(this.ahNum, crs);
    var crp = crr.encodeNetworkMessage([crn, cro], this.ahNum);
    this.eECZL.send(crp);
  },
  socketReady: function () {
    return this.eECZL && this.connected;
  }
};